import { connect } from 'react-redux';
import TargetDateView from './TargetDateView';
import { currentClientId, isPopulatedSelector } from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import { goalSelector, defaultTargetYearSelector, yearsOptionsSelector } from '../EmergencyFundWorkflowSelector';
import { BACKEND_EMERGENCY_FUND_GOAL_API } from '../EmergencyFundWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  targetYear: goalSelector(state, ownProps).FundedDate,
  defaultTargetYear: defaultTargetYearSelector(state, ownProps),
  yearsOptions: yearsOptionsSelector(state, ownProps),
  goal: goalSelector(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
  onPostProcess: (data, goal) => ({ [BACKEND_EMERGENCY_FUND_GOAL_API]: goal }),
});

export default connect(mapStateToProps, mapDispatchToProps)(TargetDateView);
